import { useQuery } from '@apollo/client';

import UserQuery from '../../graphql/queries/user.graphql';

export default function useUser() {
  return useQuery(UserQuery, { notifyOnNetworkStatusChange: true });
}
